module.exports = __webpack_public_path__ + "static/media/users.e81cdde2.svg";